import React from "react";

import { Box } from "@mui/material";
import { Container } from "@mui/system";
import useBusiness from "../../hooks/store/business";
import Loader from "../../common/Loader";
import usePermissions from "../../hooks/usePermissions";


function Demo() {
  const {scriptData,webScriptAction,loading}=useBusiness();
  const { businessId, isBusiness } = usePermissions();
  React.useEffect(() => {
    const loadScript = () => {
      if (scriptData) {
        // Parse the script content from `scriptData`
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = scriptData;
 
        const dynamicScript = tempDiv.querySelector('script');
 
        if (dynamicScript) {
          dynamicScript.async = true;
 
          // Extract necessary attributes
          const src = dynamicScript.getAttribute('src');
          const dataId = dynamicScript.getAttribute('data-id');
          const dataChatbotName = dynamicScript.getAttribute('data-chatbotName');
          const defaultAttr = dynamicScript.getAttribute('default');
          const dataChatBotId = dynamicScript.getAttribute('data-chatBotId');
 
          // Manually create the script element
          const script = document.createElement("script");
          script.src = src;
          script.async = true;
          if (dataId) script.setAttribute('data-id', dataId);
          if (dataChatbotName) script.setAttribute('data-chatbotName', dataChatbotName);
          if (defaultAttr){
            script.setAttribute('default', defaultAttr);
          }else{
            script.setAttribute('default', "close");
          }
         
          if (dataChatBotId) script.setAttribute('data-chatBotId', dataChatBotId);
 
          // Add event listeners
          script.onload = () => {};
          script.onerror = (e) => console.error("Failed to load dynamic script:", e);
 
          // Append the script to the document
          document.body.appendChild(script);
        } else {
          console.warn("No script found in the response body.");
        }
      }
    };
 
    if (isBusiness && businessId) {
      webScriptAction(businessId);
    } else {
      const script = document.createElement("script");
      script.src = "https://convio-chat-widget-dev.s3.eu-west-2.amazonaws.com/bundle.js";
      script.async = true;
      script.setAttribute('data-id', 'b3c5a896-115e-487e-b000-5aff2270f4e7');
      script.setAttribute('data-chatbotName', 'CONVIO AI');
      script.setAttribute('default', 'close');
 
      // Add event listeners
      script.onload = () => {};
      script.onerror = (e) => console.error("Failed to load static script:", e);

      document.body.appendChild(script);
    }
 
    if (isBusiness) {
      loadScript();
    }
 
    return () => {
      const existingScript = document.querySelector("script[src*='convio-chat-widget']");
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
 
      const chatbotContainer = document.querySelector("#chatbot_container");
      if (chatbotContainer) {
        chatbotContainer.remove();
      }
    };
  }, [businessId, isBusiness, scriptData, webScriptAction]);
  
  return (
    <>
   {loading &&  <Loader/>}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >
        <Container maxWidth="xl">
          {/* <Helmet>
            <script
              async
              defer
              src="https://convio-chat-widget.s3.ap-south-1.amazonaws.com/bundle.js"
              data-id="b3c5a896-115e-487e-b000-5aff2270f4e7"
              data-client-id="167b1d89-e72c-4692-a179-dc8f13d322c3"
            ></script>
          </Helmet> */}
          {/* <button onClick={addScriptToBody}>Load Script</button> */}
        </Container>
      </Box>
    </>
  );
}

export default Demo;
